"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
var react_1 = __importDefault(require("react"));
var box_1 = __importDefault(require("relements/build/esm/ui/box"));
var text_1 = __importDefault(require("relements/build/esm/ui/text"));
var MultiLineError = function (_a) {
    var error = _a.error, _b = _a.marginTop, marginTop = _b === void 0 ? 0 : _b, _c = _a.marginBottom, marginBottom = _c === void 0 ? 0 : _c;
    return error ? (react_1["default"].createElement(box_1["default"], { padding: "0", flexDirection: "column", marginTop: marginTop, marginBottom: marginBottom },
        react_1["default"].createElement(text_1["default"], { variant: "h4.semi-bold", color: "red.haptik" }, error))) : (react_1["default"].createElement(react_1["default"].Fragment, null));
};
exports["default"] = MultiLineError;
